<template>

	<div>

		<span @click="connectGoogle=true" class="large-button reconnect">Reconnect Google</span>

		<span @click="reinstateAll" v-if="table.count>0" class="large-button reinstate">Re-instate All {{table.count}} Failures</span>

		<GoogleConnect 
			v-if="connectGoogle" 
			:showLoading="true"
			@complete="googleConnectComplete"
			:externalError="googleError"
			class="google-connect"
			clientId="574338214580-bu9tl8qah4ojd8tpc7cuphkc2oke02ap.apps.googleusercontent.com"
			scope="https://www.googleapis.com/auth/adwords"
		/>

		<section class="outer-pad">

			<Table 
				:headings="headings" 
				:items="table.items" 
				:pages="table.pages"
				:page="table.page"
				:count="table.count"
				:sorted="table.sorted"
				:searchSetup="searchSetup" 
				name="admin-failures"
				emptyLabel="No failures were found"
				:loading="!fetched"
				loadingText="Fetching failures..."
				@pagination="pagination"
				@selected="keywordActions"
				@search="search"
				@removeFailures="removeFailures"
			/>

		</section>

		<ActionsBar v-if="keywordsSelected.length>0">

			<span 
				class="action-button"
				v-html="'Reinstate'"
				@click="removeFailures()"
			/>

		</ActionsBar>

	</div>

</template>

<script>
import Vue from 'vue';
import { mapMutations } from 'vuex'
import ApiService from './../../services/api.service'
import Table from './../../components/Table.vue'
import ActionsBar from './../../components/Display/ActionsBar.vue'
import GoogleConnect from './../../components/GoogleConnectAds.vue'
export default {
	name: 'AdminFailures',
	components: {
		Table,
		ActionsBar,
		GoogleConnect
	},
	data() {
		return {
			fetched: false,
			showHeadings:{},
			showCouponSetup: false,
			googleError: '',
			connectGoogle: false,
			couponSettings: { code: "", amountOffType: null },
			keywordsSelected: [],
			table: {
				items:[],
				page: 1,
				pages: 1,
				sorted: { code: 1 },
				search: {}
			}
		}
	},
	computed: {

		searchSetup () {
			
			let searchSetup = { 
				searchText: { type: 'text', placeholder: '', showLabel: 'Search Keywords' }
			};

			return searchSetup;

		},
		headings () {

			let headings = {
				c: { value: 'Select', checkBox: true, checkBoxVar: '_id' },
				keyword: { value: 'Keyword', alignHeading: 'left', alignCell: 'left' }, 
				projectName: { value: 'Project', alignHeading: 'left', alignCell: 'left' },
				failCountUndone: { value: 'Reinstate Count', alignHeading: 'left', alignCell: 'left', emptyCell: '0' },
				details: { value: 'Details', alignHeading: 'left', alignCell: 'left' }
			};

			return headings;

		}

	},
	methods: {

		...mapMutations('general',['updateLoadingText']),

		googleConnectComplete(info) {

			this.$snotify[info.status]( info.msg, 'Google' );

			this.connectGoogle = false;

		},

		keywordActions(ids) {

			Vue.set(this,'keywordsSelected',ids);

		},

		reinstateAll() {

			this.removeFailures ( 1 );

		},

		removeFailures ( all ) {

			this.$dialog
				.confirm( "Reinstate??", { okText: 'Yes please', cancelText: 'Cancel',})
				.then(function() {

					this.updateLoadingText("One moment..");

					let vars = !!all ? { _id: 'all' } : { _id: this.keywordsSelected };

					ApiService.put( 'admin/failures',vars )
			        .then( function( info ) {

			        	this.updateLoadingText();
	
			            this.submitSearch ();

			        }.bind(this))
			        .catch( function(err) {
			            console.log(err);
			        });

			        this.removeFailures(_id);

				}.bind(this))
				.catch(function() {
					

				});

		},

		search(info) {

			this.table.page = 1;
			this.table.search = info;
			this.submitSearch();

		},

		pagination(info) {

			this.table.page = info.page;
			this.submitSearch();

		},

		submitSearch () {

			let vars = { page: this.table.page, search: this.table.search };

			ApiService.post( 'admin/failures', vars )
	        .then( function( info ) {

	            let tableInfo = this.table;

				tableInfo.items = info.data.items;
				tableInfo.count = info.data.count;
				tableInfo.pages = info.data.pages;
				tableInfo.page = info.data.page;

				if ( info.sorted ) {

					tableInfo.sorted = info.sorted;

				}

				this.fetched = true;

				Vue.set(this, 'table', tableInfo);

	        }.bind(this))
	        .catch( function(err) {
	            console.log(err);
	        });

		}
		
	},
	created() {

		this.submitSearch();

	}
}
</script>
<style lang="less" scoped>
.reconnect, .reinstate {
	position: absolute;
    top: 50px;
    right: 5px;
    z-index: 5;
}
.reinstate {
	right: 220px;
}	
.google-connect {
	margin-bottom: 30px !important;
}
@media screen and (max-width: 767px) {
	.reconnect {

		display: none;

	}
}
</style>